export const FUEL_TYPES = [
    'haioku',
    'regular',
    'keiyu',
    'touyu',
];
/**
 * S-71 (本体第17条2項): データ救済期間（契約終了日からの維持日数）。
 * 契約終了から本日数の間は利用者データのエクスポート可能を維持し、経過後に削除（purge）可能になる。
 */
export const TENANT_DATA_GRACE_PERIOD_DAYS = 30;
// ============================================================================
// promo 機能パッケージ（LE-00 / LINE 顧客管理 + 行動トラッキング + 販促）
// ============================================================================
//
// MVP スコープ:
//   - 顧客マスタ = 既存 users を拡張（AppUser の interestTags / vehicles 等）
//   - 行動ログ = promo_events（イミュータブル / Callable 経由のみ書込）
//   - 配信履歴 = promo_campaigns（手動セグメント配信の記録）
//   - 開封は LINE API で取得不可 → メッセージ内リンク/リッチメニューの「タップ」を
//     代替計測（liff_link_tap / richmenu_tap）。詳細は docs の計画参照。
/**
 * 業態別の興味関心キーの全値（**この配列が唯一の真実源** / zod enum・反復・UI 選択肢はここから導出）。
 * カワイの販促対象業態に対応:
 * - `car_sales`: 新車/中古車販売（オートフラット見積・商談・査定）
 * - `inspection`: 車検（事前点検・見積）
 * - `keeper`: KeePer コーティング施工
 * - `washpass`: 洗車サブスク WashPass
 * - `fuel`: 給油（燃料）
 * 新業態追加時はこの配列に追記するだけでよい（`PromoInterestKey` 型・zod・反復が自動追従 /
 * `promoInterest.ts` のマッピングは別途更新する）。
 */
export const PROMO_INTEREST_KEYS = [
    'car_sales',
    'inspection',
    'keeper',
    'washpass',
    'fuel',
];
/**
 * アンケート回答の選択肢キー（M-78 / 設計書 §6 マトリクスの「入り方」に対応する閉集合）。
 * 選択肢の**構造**はコードで固定し、テナントは表示文言のみ上書きできる —
 * ステージ配線（M-73 / `payload.surveyChoice` の条件判定）が閉集合に依存するため。
 * - `not_interested`: 関心なし → A×self_declared + 配信抑制（§6「嫌われ防止」）
 * - `slightly_interested`: 少し気になる → I×self_declared
 * - `interested_undecided`: 関心あり・時期未定 → D×self_declared（タイプ②は減衰なしで追跡）
 * - `interested_planned`: 関心あり・時期具体 → D×self_declared（M-76 HOT 判定の入力）
 */
export const SURVEY_CHOICE_KEYS = [
    'not_interested',
    'slightly_interested',
    'interested_undecided',
    'interested_planned',
];
// ---------- promo: HOT 案件（M-76 / 設計書 §7 タイプ②） ----------
/**
 * HOT 案件のステータス（§7「新規 → 対応中 → 成約 / 見送り」）。
 * 保存値は英語・表示は tenant-promo の `HOT_LEAD_STATUS_LABELS` で日本語化する
 * （`PromoPlanStatus` と同方針 — 表示文言の変更でマイグレーションが要らない）。
 * - `new`: 起票直後（担当者未対応）
 * - `in_progress`: 担当者が対応開始（この間は自動配信を抑制 = 商談への割込み防止）
 * - `won`: 成約（`hot_won` イベントで Act 反映）
 * - `lost`: 見送り・時期延期（追跡モードへ戻す = タイプ②は D が減衰しないため保持される）
 */
export const HOT_LEAD_STATUSES = ['new', 'in_progress', 'won', 'lost'];
/** クローズ済み（成約 / 見送り）ステータスか。再起票の冷却判定に使う。 */
export const HOT_LEAD_CLOSED_STATUSES = [
    'won',
    'lost',
];
/** `PromoHotLead.notes` の保持上限（超過分は古い順に切り捨て / doc サイズ 1MiB 制約の保険）。 */
export const HOT_LEAD_NOTES_MAX = 50;
//# sourceMappingURL=types.js.map